import 'date-fns';
import React from 'react'
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import star_icon from '../../assets/images/icons/star-icon.png'





const DatePicker = (props)=>{

    return(
        <div className="horizontal-text-input-container">
            <div className="horizontal-text-input-header">
                <span className="general-span-text-none-auto-small">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
          <div className="dashboard-textfield-input">
            <MuiPickersUtilsProvider 
              utils={DateFnsUtils}>
              <Grid 
                container 
                justifyContent="space-around"
                style={{width: '94%'}}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label=""
                  format="MM/dd/yyyy"
                  value={props.value}
                  onChange={props.handleDateOfBirth}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{width: '100%'}}
                  // error={true}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </div>
        </div>

    )
}

export default DatePicker